/**
 * Add a message to show up in the UI.
 * @param {Object} state - The current state.
 * @param {Object} action - Details of the request to the reducer being made.
 * @return {Object} The new state.
*/

export default function addMessage(state, action) {
  const { key, message } = action

  return Object.assign({}, state, {
    messages: {
      ...state.messages,
      [key]: message
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addMessage.js